// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-footer[data-v-814da84e] {\n  text-align: right;\n  padding-top: 20px;\n}\n.box-card[data-v-814da84e] {\n  width: 675px;\n}\n.address[data-v-814da84e] {\n  width: 450px;\n}\n[data-v-814da84e] .el-card__body {\n  padding: 0 15px 15px 0 !important;\n}", ""]);
// Exports
module.exports = exports;
